import { UserDetails, DailyParadeSummary, ParadePresentAbsentSummary, Dashboard } from "../Components/index.js";

export default [
    {
        path: "/dashboard/parade-state",
        component: Dashboard,
        name: "dashboard-parade-state",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/parade/user/:user_id",
        component: UserDetails,
        name: "report-parade-user-details",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/daily-parade/summary",
        component: DailyParadeSummary,
        name: "report-daily-parade-summary",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/daily-parade-present-absent/summary",
        component: ParadePresentAbsentSummary,
        name: "report-daily-parade-present-absent",
        meta: {
            requiresAuth: true,
        },
    },
];
